import React from "react";
import { Link } from "gatsby"
import { startCase, capitalize } from "lodash";

import { defaultArea, defaultArea_Slug, country} from "../../../../common/constant"
import { PageLinks } from "../../../../common/page-links";
import { PropertySearchUrl } from "../../../../common/utils/property_utils"
import { PopularSearch } from "../../../../common/queries/common_use_query"
import ContentModule from "../../../../modules/content_module";

const PropertyStaticPages = ({searchParams, page_slug}) => {

    const{loading, error, data} = PopularSearch(page_slug);

    var area = searchParams.areas ? (searchParams.areas === defaultArea.toLowerCase() ? country : searchParams.areas.replace(/"/g, "")) : country;

    if(area.length < 5){
        area = area.toUpperCase();
    } else {
        area = capitalize(area);
    }

    var area_slug = searchParams.areas ? searchParams.areas : defaultArea_Slug;
    area_slug = (area_slug.replace(/ /g, '-')).toLowerCase();
    
    var property_url = PropertySearchUrl(searchParams.department, searchParams.search_type)

    //console.log("area", area, searchParams)

    return (
        loading ? ''
        :
        <>
        {data?.menus?.length > 0 ?
            data?.menus[0]?.popular_search.length > 0 && data?.menus[0]?.popular_search?.map((item, index) => {
                return(
                    <ContentModule Content={item.popular_search.content.replace(/{area}/g,area)} />
                )
                })
            :
            <ul>
                <li><Link to={`/${PageLinks.branch_finder}/`}>Estate agents in {area}</Link></li>
                <li><Link to={`/${PageLinks.property_management}/`}>Property management in {area}</Link></li>
                <li><Link to={`/${PageLinks.request_valuation}/`}>Property valuation in {area}</Link></li>
                <li><Link to={`/${PageLinks.financial_services}/`}>{area} financial services</Link></li>
            </ul>
        }
        </>
    )
}
export default PropertyStaticPages;